import { useState, useEffect } from 'react'

// Initialize to 24h in seconds
const INITIAL_TIME = 24 * 3600

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME)

  useEffect(() => {
    if (timeLeft <= 0) return

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => Math.max(0, prev - 1))
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isFinished: timeLeft === 0,
  }
}
